import React from 'react';

import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-metrics';

import CurrencyFormatter from '@utils/CurrencyFormatter';

import HomeCard from '../../../common/components/Homecard';

import './FavoritesHomecard.scss';

const FavoritesHomecard = props => {
  const { homecard, onClick, onToggleFavorite } = props;

  const { id, currencyLabel, currencySymbol, currencyIsoCode } = homecard;

  const currency = new CurrencyFormatter(
    currencyLabel,
    currencySymbol,
    currencyIsoCode
  );

  const handleHomecardClick = () => {
    Metrics.ga.sendEvent('Favorites', 'view favorite', 'click homecard');
    onClick();
  };

  return (
    <div className={'favorites-home-card__wrapper'}>
      <HomeCard
        isFavorite
        id={id}
        data={{
          ...homecard
        }}
        onToggleFavorite={onToggleFavorite}
        currency={currency}
        onClick={handleHomecardClick}
      />
    </div>
  );
};

FavoritesHomecard.propTypes = {
  homecard: PropTypes.shape({
    id: PropTypes.string,
    currencyLabel: PropTypes.string,
    currencySymbol: PropTypes.string,
    currencyIsoCode: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  onToggleFavorite: PropTypes.func
};

FavoritesHomecard.defaultProps = {
  onClick: () => {},
  onToggleFavorite: () => {}
};

export default FavoritesHomecard;
